import { useMutation } from '@tanstack/react-query';

import { authMutationKeys } from '../../config/auth-mutation-keys';
import { handleAxiosError } from '../../utils/handle-axios-error';
import { getPasswordResetApi } from './client';
import { encryptPasswordResetPayload } from './encrypt-password-reset-payload';
import type {
  CompletePasswordResetRequest,
  CompletePasswordResetResponse,
  PasswordResetFormEncryptionResponse,
} from './types';

async function completePasswordReset({
  confirmPassword,
  password,
  token,
}: CompletePasswordResetRequest): Promise<CompletePasswordResetResponse> {
  try {
    const passwordResetApi = getPasswordResetApi();
    const encryptionResponse =
      await passwordResetApi.get<PasswordResetFormEncryptionResponse>(
        '/encryption'
      );
    const encryptedBody = await encryptPasswordResetPayload({
      payload: {
        confirmPassword,
        password,
        token,
      },
      publicKey: encryptionResponse.data.publicKey,
    });
    const response = await passwordResetApi.post<CompletePasswordResetResponse>(
      '/complete',
      encryptedBody
    );

    return response.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
}

export function useCompletePasswordResetMutation() {
  return useMutation({
    mutationFn: (args: CompletePasswordResetRequest) =>
      completePasswordReset(args),
    mutationKey: authMutationKeys.completePasswordResetRequest(),
  });
}
